export interface IInstrumentBasicData {
    id: string;
    name: string;
}

export class InstrumentBasicData implements IInstrumentBasicData {
    id: string;
    name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

const defaultInstrumentBasicData = new InstrumentBasicData("", "");
export { defaultInstrumentBasicData }